import React from 'react';
import { deleteUser, signOut } from 'firebase/auth';
import { auth } from './firebaseConfig';
import './Settings.css';

const Settings = ({ user, userData, toggleSearchFallback }) => {

  const isSearchActive = userData?.searchFallback; 

  return (
    <div className="ozia-page-container">
      <header className="page-header">
        <h1>Preferences</h1>
        <p>Configure how OZIA AI interacts with the web and your data.</p>
      </header>

      <div className="settings-grid">
        <section className="settings-card">
          <div className="card-header">
            <i className="fas fa-sliders-h"></i>
            <h3>App Behavior</h3>
          </div>
          <div className="card-body">
            <div className="toggle-row">
              <div className="toggle-info">
                <label>Web Search Fallback</label>
                <p>Allow AI to search the web when local data is insufficient.</p>
              </div>
              <div 
                className={`custom-toggle ${userData?.searchFallback ? 'active' : ''}`}
                onClick={toggleSearchFallback}
              ></div>
            </div>
          </div>
        </section>

        <section className="settings-card danger-zone">
          <div className="card-header">
            <i className="fas fa-exclamation-triangle"></i>
            <h3>Danger Zone</h3>
          </div>
          <div className="card-body">
            <p>Once you delete your account, there is no going back. Please be certain.</p>
            <button className="settings-btn-danger" onClick={() => {/* handle delete */}}>
              Delete All Data
            </button>
          </div>
        </section>
      </div>
    </div>
  );
};
export default Settings;